import { IconName } from "PFTheme/graphics/icons";

export const CONTACT_TYPE_TO_ICON_MAP: Record<string, IconName> = {
  email: "mail",
  twitter: "twitter",
  facebook: "facebook",
  instagram: "instagram",
  website: "web",
  phone: "mobile",
  ms_teams: "teams"
};
